/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from "react";
import get from "lodash/get";
import { Surface } from "../../atoms/surface";
// import Razorpay from "../../../../assets/images/razorpay.svg";
import Stripe from "../../../../assets/images/stripe.svg";
import assetify from "@quintype/framework/assetify";
import { Checkbox } from "../../atoms/checkbox";
import { useSelector, useDispatch } from "react-redux";
import { useScript } from "../../../utils";
import { IS_OPEN_LOGIN_FORM } from "../../helper/actions";
import { getStudentSubscriptionPaymentLink } from "../../helper/api";
import { SocialMediaShoutoutContainer } from "./social-media-shoutout-container";
import IntegrationData from "../../../../../config/integrations.js";

import "./student-subscription-page.m.css";

export function SponsorStudentSubscriptionPage() {
  const status = useScript("https://js.stripe.com/v3");

  const [data, setData] = useState({
    quantity: 2,
    gateway: "stripe",
    plan: 6,
    recurring: false
  });
  const {
    gateway,
    plan,
    recurring,
    quantity,
    instagramHandle,
    twitterHandle
  } = data;

  const integrationsConfig = IntegrationData();
  const member = useSelector(state => get(state, ["member"], null));
  const dispatch = useDispatch();
  const showLoginPopup = () => {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: true
    });
  };
  const frontEndURL = useSelector(state =>
    get(state, ["qt", "config", "publisher", "frontend_url"], "")
  );

  const plans = integrationsConfig.studentSubscriptionPlans;
  const type = recurring ? "recurring" : "oneTime";
  const mode = recurring ? "subscription" : "payment";

  const handleChange = e => {
    const { name, value } = e.target;
    setData(prevState => ({ ...prevState, [name]: value }));
  };

  const [renderSuccessPage, setRenderSuccessPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const stripeRef = useRef(null);

  useEffect(() => {
    if (window.location.search.indexOf("success") > -1) {
      setRenderSuccessPage(true);
    }

    if (status === "ready") {
      const STRIPE_KEY = integrationsConfig.appKeys.stripeKey;
      stripeRef.current = window.Stripe(STRIPE_KEY);
    }
  }, [status, integrationsConfig]);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!member) {
      await showLoginPopup();
      return;
    }

    try {
      if (gateway === "stripe") {
        const amount = plans[type][plan].amount * parseInt(quantity);
        stripeRef.current.redirectToCheckout({
          clientReferenceId: member.id.toString(),
          lineItems: [
            {
              price: plans[type][plan].stripe_key,
              quantity: parseInt(quantity)
            }
          ],
          mode,
          successUrl: `${frontEndURL}/sponsor-student-subscription?success=true&gateway=stripe&quantity=${quantity}&amount=${amount}`,
          cancelUrl: frontEndURL + "/sponsor-student-subscription"
        });
      } else {
        const request = {
          gateway,
          quantity: parseInt(quantity),
          plan: parseInt(plan),
          recurring,
          customerId: member.id,
          twitterHandle,
          instagramHandle
        };
        setLoading(true);

        try {
          const res = await getStudentSubscriptionPaymentLink(request);
          window.location = res.redirect_url;
        } catch (error) {
          setError(error.message);
        } finally {
          setLoading(false);
        }
      }
    } catch (e) {
      setError("something went wrong");
      console.log("error while completing payment ", e);
    }
  };

  return (
    <Surface>
      {renderSuccessPage ? (
        <SocialMediaShoutoutContainer />
      ) : (
        <form onSubmit={handleSubmit}>
          <h1>Fill the below form to sponsor subscription for Students</h1>
          <div style={{ height: "1rem" }}></div>
          <div styleName="form-group">
            <label htmlFor="quantity" styleName="text">
              Enter number of students
            </label>
            <input
              styleName="input-text"
              value={quantity}
              id="quantity"
              min="1"
              type="number"
              name="quantity"
              onChange={handleChange}
            ></input>
          </div>
          <div styleName="form-group">
            <label htmlFor="plan" styleName="text">
              Select plan
            </label>
            <select value={plan} onChange={handleChange} id="plan" name="plan">
              <option disabled>Select plan</option>
              {Object.keys(plans.oneTime).map(val => {
                return (
                  <option key={val} value={val}>
                    {plans.oneTime[val].label}
                  </option>
                );
              })}
            </select>
          </div>
          <div styleName="form-group">
            <div styleName="text">Select Payment Method</div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {/* <div styleName="payment-wrapper">
                <div styleName="checkbox-wrapper">
                  <Checkbox
                    id="razorpay"
                    value="razorpay"
                    name="gateway"
                    type="radio"
                    checked={gateway === "razorpay"}
                    onChange={handleChange}
                  />
                  <span styleName="checkmark"> </span>
                  <img styleName="image" src={assetify(Razorpay)} alt="razorpay" />
                </div>
                <div styleName="option-name">Credit/Debit card, UPI, Netbanking</div>
              </div> */}

              <div styleName="payment-wrapper">
                <div styleName="checkbox-wrapper">
                  <Checkbox
                    id="stripe"
                    value="stripe"
                    name="gateway"
                    type="radio"
                    checked={gateway === "stripe"}
                    onChange={handleChange}
                  />
                  <span styleName="checkmark"> </span>
                  <img styleName="image" src={assetify(Stripe)} alt="stripe" />
                </div>
                <div styleName="option-name">Credit/Debit card</div>
              </div>
            </div>
          </div>

          {/* <div>
            <label htmlFor="recurring" styleName="text">
              Recurring?
            </label>
            <input
              type="checkbox"
              checked={recurring}
              onChange={e => setData({ ...data, recurring: e.target.checked })}
              name="recurring"
              id="recurring"
            ></input>
          </div> */}

          <button styleName="pay-button" type="submit" disabled={loading}>
            Pay (
            {quantity > 0
              ? "₹" + plans[type][plan].amount * parseInt(quantity)
              : null}
            )
          </button>
        </form>
      )}
      {error}
    </Surface>
  );
}
